import client from '@/lib/http-client';

export default {
	getData(params, cb, errorCb, client) {
		const url = `/${params.username}/product/${params.slug}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getPublicProduct(id, params, cb, errorCb) {
		const url = `/product/${id}/public`;
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getProvinces(params, cb, errorCb) {
		const url = '/shipping/provinces';
		client
			.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
